import './SegmentedToggle.css';

interface SegmentedToggleProps<T extends string> {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  label?: string;
}

export const SegmentedToggle = <T extends string>({ options, value, onChange, label }: SegmentedToggleProps<T>) => {
  return (
    <div className="segmented-toggle-container">
      {label && <span className="segmented-toggle-label">{label}</span>}
      <div className="segmented-toggle" role="radiogroup" aria-label={label}>
        {options.map((option) => (
          <button
            key={option.value}
            className={`toggle-btn ${value === option.value ? 'active' : ''}`}
            onClick={() => { onChange(option.value); }}
            role="radio"
            aria-checked={value === option.value}
            type="button"
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};
